import type { GA4EventName } from './ga4Events';

export function pushToDataLayer(event: GA4EventName, params: Record<string, unknown> = {}): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

function camelToSnake(key: string): string {
  return key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
}

/**
 * Converts the (flat) keys of an object from camelCase to snake_case. Use this
 * only for payloads whose field names map cleanly to the taxonomy
 * (e.g. `routeId` -> `route_id`). Renamed or derived fields must be built
 * explicitly in the adapter, not via this helper.
 */
export function toSnakeCaseKeys(obj: object): Record<string, unknown> {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [camelToSnake(key), value]));
}

export function toNumberOrNull(value: string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
